import { render, staticRenderFns } from "./PromptNextContactModal.vue?vue&type=template&id=8961f056&"
import script from "./PromptNextContactModal.vue?vue&type=script&lang=js&"
export * from "./PromptNextContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports